import Element from '../../../core/Element';
import { Size, Color, FontType, Type, VAlign } from '../../../core/enums';
import type { Tools } from '../../../core/types';
import { Box } from '../../archived/box';
import Button from '../../archived//button';
import { ContentBannerWithImageAndCard } from '../../banners/content-banner-with-image-and-card';
import { Typography } from '../../archived/typography';
import styles from './index.module.less';

interface ContentTileWithImageAndCardProps {
  data: {
    title: string;
    text?: string;
    button: {
      ariaLabel?: string;
      text: string;
      onClick: () => void;
      tools: Tools;
    };
    cardImage?: string;
    cardImageAlt?: string;
    backgroundCardImage:
      | string
      | {
          _default?: string;
          sm?: string;
          md?: string;
          lg?: string;
        };
  };
  $cardSize?: {
    sm?: Size;
    md?: Size;
    lg?: Size;
  };
  $bodyPosition?: 'left' | 'right';
  customization?: {
    title: {
      htmlTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    };
  };
  qeId?: string;
}

export const ContentTileWithImageAndCard = ({
  data: { cardImage, cardImageAlt, title, text, button, backgroundCardImage },
  $cardSize,
  $bodyPosition,
  customization = {
    title: {
      htmlTag: 'h3',
    },
  },
  qeId = 'ContentTileWithImageAndCard',
}: ContentTileWithImageAndCardProps) => (
  <Box
    qeId={qeId}
    $shadow="light"
    $border
    $overflow="hidden"
    theme={{ rounded: Size.SM, borderColor: Color.Gray02 }}
  >
    <ContentBannerWithImageAndCard
      data={{
        body: (
          <Element theme={{ paddingLeft: 10 }}>
            <Typography
              Component={customization.title.htmlTag}
              $family={FontType.BentonBold}
              $size={30}
              theme={{
                textHeading: 5,
                color: Color.DeepBlue,
                padding: 'none',
                margin: 'none',
              }}
            >
              {title}
            </Typography>

            <Element
              Component="p"
              theme={{
                textBody: 3,
                color: Color.Gray06,
                padding: 'none',
                margin: 'none',
                paddingTop: 10,
                paddingBottom: 30,
              }}
            >
              {text}
            </Element>

            <div className={styles.button}>
              <Button
                aria-label={button.ariaLabel}
                $type={Type.Secondary}
                theme={{ horizontallyFluid: true }}
                tools={button.tools}
                onClick={button.onClick}
              >
                {button.text}
              </Button>
            </div>
          </Element>
        ),
        imageUrl: backgroundCardImage,
        cardImage,
        cardImageAlt,
      }}
      $bodyPosition={$bodyPosition}
      $bodyContentPosition={VAlign.Center}
      $cardSize={$cardSize}
    />
  </Box>
);
